import { useState } from 'react';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';
import AmountInput from '../components/AmountInput';
import { parseAmountInput } from '../lib/format';

interface Props {
  onDone: () => void;
  onBack: () => void;
}

export default function StartingBalance({ onDone, onBack }: Props) {
  const [usd, setUsd] = useState('');
  const [syp, setSyp] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);

  async function submit(ev: React.FormEvent) {
    ev.preventDefault();
    const u = usd.trim() ? parseAmountInput(usd) : 0;
    const s = syp.trim() ? parseAmountInput(syp) : 0;
    if (u === null || s === null) { setErr('Amounts must be valid numbers.'); return; }
    if ((u ?? 0) === 0 && (s ?? 0) === 0) { setErr('Enter at least one amount.'); return; }
    setErr(null);
    setBusy(true);
    try {
      await api.setStartingBalance(u ?? 0, s ?? 0);
      haptic('success');
      onDone();
    } catch (e) {
      haptic('error');
      setErr(e instanceof Error ? e.message : 'failed to save');
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <div className="header">
        <button className="back" onClick={onBack}>← Back</button>
        <h1>Starting balance</h1>
      </div>
      {err && <div className="error">{err}</div>}

      <form onSubmit={submit}>
        <div className="card">
          <p className="muted small" style={{ marginTop: 0 }}>
            Enter the cash you already have on hand. This sets your starting balance — it won't be counted as income earned this month.
          </p>

          <label className="label">USD on hand</label>
          <AmountInput value={usd} onChange={setUsd} currency="USD" placeholder="0" autoFocus />

          <label className="label">SYP on hand</label>
          <AmountInput value={syp} onChange={setSyp} currency="SYP" placeholder="0" />

          <p className="muted small" style={{ marginTop: 12, marginBottom: 0 }}>
            Leave a field blank or 0 if you have none of that currency.
          </p>
        </div>

        <button type="submit" className="btn" disabled={busy}>
          {busy ? 'Saving…' : 'Set starting balance'}
        </button>
      </form>
    </>
  );
}
